import api from '../api';
import { newsletterApi, whatsTrendingApi } from '../apiVariables';

const handleApiCall = (apiConfig: any) => {
  return new Promise((resolve, reject) => {
    api(apiConfig).then(resolve).catch(reject);
  });
};

export const getMarketingApis = (
  subTab: string,
  startDate?: string,
  endDate?: string,
  current?: number,
  pageSize?: number
) => {
  let api = '';
  if (subTab === 'why-choose-equentis') {
    api = `/api/marketing/why-choose-equentis`;
  } else if (subTab === 'podcast') {
    api = `/api/marketing/podcast`;
  } else if (subTab === 'myth-busters') {
    api = `/api/marketing/myth-busters`;
  } else if (subTab === 'product-notes') {
    api = `/api/marketing/product-notes`;
  } else if (subTab === 'customer-testimonials-pr') {
    api = `/api/marketing/customer-testimonials-pr`;
  } else if (subTab === 'calculators') {
    api = `/api/marketing/calculators`;
  }

  if (startDate || endDate || current || pageSize) {
    let filters = '?';
    if (startDate) {
      filters += `&start_date=${startDate}`;
    }
    if (endDate) {
      filters += `&end_date=${endDate}`;
    }
    if (current) {
      filters += `&page=${current}`;
    }
    if (pageSize) {
      filters += `&pageSize=${pageSize}`;
    }
    api += filters;
  }
  const { getTrendingParameters: whatsTrendingConfig } = whatsTrendingApi;
  const apiConfig = { ...whatsTrendingConfig, api: api };
  return handleApiCall(apiConfig);
};

export const logMarketingEvent = async (body: any) => {
  const { logMarketingMaterial: logMarketingConfig } = whatsTrendingApi;
  return handleApiCall({ ...logMarketingConfig, body });
};